import Vue from 'vue'
import { NavigationGuard, NavigationGuardNext } from 'vue-router'
import _ from 'lodash'

export function resolve(guards: NavigationGuard[]): NavigationGuard {
  return (to, from, next) => {
    const queue = guards.slice(0)
    function nextGuard(...args: Parameters<NavigationGuardNext<Vue>>) {
      const guard = queue.shift()
      // 次のガードが存在する、かつ、前のガードでnextが設定されていない場合、次のガードへ進む
      guard && _.isEmpty(args) ? guard(to, from, nextGuard) : next(...args)
    }
    nextGuard()
  }
}
